import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { valdiatePage } from "../../global";
import { getSubAccountLocations } from "../../services/userservice";
import { getLoadsheets, getLoadsheetCNs } from "../../services/loadsheetservice";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { setData, updateData as updateD, resetData, setLocations, setGrid, setSelectedLocations } from "../../redux/seachLoadSheetSlice";
import Pagination from '../../components/paginations';
import ExportExcelButton from "../../components/exportExcelButton"; 

export const exportDetailsColumns = [
  { label: "Consignment No", key: "cn" },
  { label: "Customer Ref No", key: "refNo" },
  { label: "Booking Date", key: "bookingDate" },
  { label: "COD Amount", key: "codAmount" },
  { label: "Destination", key: "destination" },
  { label: "Service Type", key: "serviceType" },
  { label: "Weight", key: "weight" },
  { label: "Pieces", key: "pcs" },
];

const ExportDetails = ({ index, data, resetExportData }) => {
  useEffect(() => {
    if (data && data.length > 0) {
      const { exportExcel } = require("../../utils/exportExcel");
      exportExcel(data, 'Loadsheet', exportDetailsColumns);
      resetExportData(index);
    }
  }, [index, resetExportData]);

  return null; 
};
 const SearchLoadsheets = () => {
  const dispatch = useDispatch();
  const { appData, searchLoadSheetData } = useSelector((state) => ({
    appData: state.appData,
    searchLoadSheetData: state.searchLoadSheetData,
  }));

  const { loading, userInfo, subaccounts } = appData;
  const { data, locations, grid, selectedLocations } = searchLoadSheetData;
  const history = useHistory();

  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending'});
  const [originalGrid, setOriginalGrid] = useState([]);

  const searchObjInit = {
    loadsheetId: '',
  };
  const [searchObject, setSearchObj] = useState(searchObjInit);
  const updateSearchData = (key, val) =>
    setSearchObj((prev) => ({ ...prev, [key]: val }));

  const gridKeys = [
    { key: "loadsheetId", name: "Loadsheet Id", searchBox: true, visible: true },
    { key: "totalCNs", name: "Total CNs", searchBox: false, visible: true },
    { key: "creationDate", name: "Date", searchBox: false, visible: true },
    { key: "th4", name: "", searchBox: false, visible: true },
    { key: "th5", name: "", searchBox: false, visible: true },
  ];

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const filterData = useMemo(() => {
    return grid.filter(
      (item, index) => index >= page * pageLimit && index < (page + 1) * pageLimit
    );
  }, [page, grid, pageLimit]);


const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
 });

  useEffect(() => {
    if (!valdiatePage("/searchloadsheets")) {
      history.push("/login");
    }

    return () => {
      dispatch(resetData({}));
      dispatch(setGrid({ data: [] }));
      dispatch(setLocations({ data: [] }));
    };
  }, [dispatch, history]);

  const updateData = (key, val) => {
    dispatch(updateD({ key, val }));
  };

  const onSearch = async () => {
    if (!data.subAccountId) return alert("Select Sub Account");
    if (selectedLocations.length === 0) return alert("Select Location");
    if (!data.from) return alert("Select From Date");
    if (!data.to) return alert("Select To Date");
    if (Date.parse(data.from) > Date.parse(data.to)) return alert("Invalid Date Selection");

    const payload = {
      locationId: 0,
      from: data.from,
      to: data.to,
      locations: selectedLocations,
    };

    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheets(payload);
    dispatch(setLoading({ data: false }));

    if (rs?.ok) {
      dispatch(setGrid({ data: rs.data }));
      setOriginalGrid(rs.data);
    }
  };

  const onGenerate = async (id, locations) => {
    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheetCNs({ loadsheetId: id, locations });
    dispatch(setLoading({ data: false }));

    if (rs?.ok) {
      const printData = {
        lid: id,
        customerName: userInfo.name,
        accountNo: data.accountNo,
        data: rs.data,
      };
      sessionStorage.setItem("loadsheetdata2", JSON.stringify(printData));
      window.open("/cplight/loadsheetinfo.html", "_blank");
    }
  };

  const exportData = async (id, index, locations) => {
    dispatch(setLoading({ data: true }));
    const rs = await getLoadsheetCNs({ loadsheetId: id, locations });
    dispatch(setLoading({ data: false }));

    if (rs?.ok) {
      const g = [...grid];
      g[index] = { ...g[index], details: rs.data };
      dispatch(setGrid({ data: g }));
    }
  };

  const resetExportData = (index) => {
    const g = [...grid];
    g[index] = { ...g[index], details: null };
    dispatch(setGrid({ data: g }));
  };

  return (
    userInfo && (
      <section className="section">
        <div className="section-header">
          <h1>Search Loadsheets</h1>
        </div>

        <div className="card" style={{ padding: 10 }}>
          {/* Filters */}
          <div className="row">
            <div className="col-lg-2">
              <label>Sub Account</label>
              <select
                className="form-select"
                value={data.subAccountId}
                onChange={async (e) => {
                  const val = e.target.value;
                  const accno = e.target[e.target.selectedIndex].getAttribute("data-accno");
                  dispatch(
                    setData({
                      data: { ...data, subAccountId: val, locationId: "", accountNo: accno },
                    })
                  );
                  dispatch(setSelectedLocations({ data: [] }));
                  if (val) {
                    const locs = await getSubAccountLocations(userInfo.id, val);
                    dispatch(setLocations({ data: locs || [] }));
                  } else {
                    dispatch(setLocations({ data: [] }));
                  }
                }}
              >
                <option value="">Select Sub Account</option>
                {subaccounts.map((x, index) => (
                  <option key={index} value={x.id} data-accno={x.accountNo}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-2">
              <label>Locations</label>
              <select
                className="form-select"
                value={selectedLocations}
                onChange={(e) => {
                  const values = Array.from(e.target.selectedOptions, (opt) => opt.value);
                  dispatch(setSelectedLocations({ data: values }));
                }}
                multiple
              >
                {locations.map((x, index) => (
                  <option key={index} value={x.value}>
                    {x.text}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-2">
              <label>Order From</label>
              <input
                type="date"
                className="form-control"
                value={data.from}
                onChange={(e) => updateData("from", e.target.value)}
              />
            </div>

            <div className="col-lg-2">
              <label>Order To</label>
              <input
                type="date"
                className="form-control"
                value={data.to}
                onChange={(e) => updateData("to", e.target.value)}
              />
            </div>

            <div className="col-lg-2">
              <button
                type="button"
                className="btn btn-primary"
                disabled={loading}
                onClick={onSearch}
                style={{ marginTop: 30 }}
              >
                Search
              </button>
            </div>
          </div>

          <br />

          {originalGrid.length > 0 && (
            <Pagination
              setGrid={(result) => dispatch(setGrid({ data: result }))}
              searchObjInit={searchObjInit}
              searchObject={searchObject}
              originalGrid={originalGrid}
              setPage={setPage}
              setPageLimit={setPageLimit}
              requestSort={requestSort}
              sortConfig={sortConfig}
              updateSearchData={updateSearchData}
              sortedArray={sortedArray}
              data={data}
              dataCount={grid.length}
              pageLimit={pageLimit}
              gridKeys={gridKeys}
              page={page}
              grid={sortedArray.map((x, index) => (
                <tr key={index}>
                  <td>{index + 1 + page * pageLimit}</td>
                  <td>{x.loadsheetId}</td>
                  <td>{x.totalCNs}</td>
                  <td>{x.creationDate}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => onGenerate(x.loadsheetId, x.locations)}
                    >
                      Generate Loadsheet
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => exportData(x.loadsheetId, index, x.locations)}
                    >
                      Export
                    </button>

                    {x.details?.length > 0 && (
                      <ExportDetails
                        index={index}
                        data={x.details}
                        resetExportData={resetExportData}
                      />
                    )}
                  </td>
                </tr>
              ))}
            />
          )}
        </div>
      </section>
    )
  );
};

export default SearchLoadsheets;